// Module
var code = "<h2 class=\"interiorSectionHeading\">Tax Information</h2> <ul> <li> View your student loan interest or canceled debt for tax filing purposes.</li> <li> <strong>Print 1098-E or 1099-C tax forms.</strong></li> </ul> ";
// Exports
export default code;